import React from "react";

const ErrorTemplate = () => {
  return (
    <div className="alert alert-danger alert-dismissible fade show mt-4 shadow-sm" role="alert">
      <strong>Error!</strong> You should type something.
    </div>
  );
};

export default ErrorTemplate;
